import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import ForgetPassword from '../views/ForgetPassword.vue';
import Signup from '../views/Signup.vue';
import Dashboard from '../views/Dashboard.vue';
import Profile from '../views/Profile.vue';
import OtherProfile from '../views/OtherProfile.vue';
import Messages from '../views/Messages.vue';
import Network from '../views/Network.vue';
import Search from '../views/Search.vue';
import Music from '../views/Music.vue';
import Ads from '../views/Ads.vue';
import ChallengeDetail from '../views/ChallengeDetail.vue';
import News from '../views/News.vue';
import Challenges from '../views/Challenges.vue';
import Articles from '../views/Articles.vue';
import GroupDetail from '../views/GroupDetail.vue';
import Featured from '../views/Featured.vue';
import NewsDetail from '../views/NewsDetail.vue';
import Resubscribe from '../views/Resubscribe.vue';
import ArticleDetail from '../views/ArticleDetail.vue';
import Notifications from '../views/Notifications.vue';
import SinglePost from '../views/SinglePost.vue';
import DashboardLayout from '../components/layouts/DashboardLayout.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'DashboardLayout1',
		component: DashboardLayout,
		props: true,
		redirect: '/dashboard',
		children: [
			{
				path: '/profile/:id',
				name: 'Other Profile',
				component: OtherProfile,
			},
		],
	},
	{
		path: '/',
		name: 'DashboardLayout',
		component: DashboardLayout,
		props: true,
		redirect: '/dashboard',
		meta: {
			isAuthRequire: true,
		},
		children: [
			{
				path: '/dashboard',
				name: 'Dashboard',
				component: Dashboard,
			},
			{
				path: '/profile',
				name: 'Profile',
				component: Profile,
			},
			{
				path: '/post/:id',
				name: 'Post',
				component: SinglePost,
			},
			{
				path: '/messages',
				name: 'Messages',
				component: Messages,
			},
			{
				path: '/network',
				name: 'Network',
				component: Network,
			},
			{
				path: '/search',
				name: 'Search',
				component: Search,
			},
			{
				path: '/featured',
				name: 'Featured',
				component: Featured,
			},
			{
				path: '/resubscribe',
				name: 'Resubscribe',
				component: Resubscribe,
			},
			{
				path: '/music-room',
				name: 'Music',
				component: Music,
			},
			{
				path: '/group/:id',
				name: 'Group',
				component: GroupDetail,
			},
			{
				path: '/news-detail/:id',
				name: 'News Detail',
				component: NewsDetail,
			},
			{
				path: '/challenge-detail/:id',
				name: 'Challenge Detail',
				component: ChallengeDetail,
			},
			{
				path: '/challenges',
				name: 'Challenges',
				component: Challenges,
			},
			{
				path: '/news',
				name: 'News',
				component: News,
			},
			{
				path: '/article/:id',
				name: 'Article',
				component: ArticleDetail,
			},
			{
				path: '/articles',
				name: 'Articles',
				component: Articles,
			},
			{
				path: '/ads',
				name: 'Ads',
				component: Ads,
			},
			{
				path: '/notifications',
				name: 'Notifications',
				component: Notifications,
			},
		],
	},

	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			isAuthRequire: false,
		},
	},
	{
		path: '/signup',
		name: 'Signup',
		component: Signup,
		meta: {
			isAuthRequire: false,
		},
	},
	{
		path: '/forget-password',
		name: 'Forget Password',
		component: ForgetPassword,
		meta: {
			isAuthRequire: false,
		},
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
